import React from "react";
import "./FreeTag.scss"

function FreeTag (){

  return(
    <div className="option-free">Gratuito</div>
  )
}

export default FreeTag
